import React, { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import { Icon, Tag as USWDSTag } from '@ver-uds/uswds-react';

type IconProps = ComponentPropsWithoutRef<typeof Icon>;

type TagVariantType =
  | 'dark'
  | 'light'
  | 'primary'
  | 'error'
  | 'warning'
  | 'success'
  | 'primary-darker'
  | 'primary-lighter'
  | 'error-lighter'
  | 'warning-lighter'
  | 'success-lighter';

export interface TagProps {
  children: React.ReactNode;
  className?: string;
  iconLeft?: React.ReactElement<IconProps>;
  iconRight?: React.ReactElement<IconProps>;
  id?: string;
  size?: 'large';
  variant?: TagVariantType;
}

const Tag = ({ children, className, iconLeft, iconRight, id, size, variant }: TagProps): JSX.Element => {
  return (
    <USWDSTag
      id={id}
      className={classNames(
        'ver-tag',
        { [`ver-tag--${variant || ''}`]: variant, [`ver-tag--${size || ''}`]: size },
        className,
      )}
    >
      {iconLeft && <span className="ver-tag__icon ver-tag__icon--left">{iconLeft}</span>}
      {children}
      {iconRight && <span className="ver-tag__icon ver-tag__icon--right">{iconRight}</span>}
    </USWDSTag>
  );
};

export default Tag;
